import React from 'react'

export default class DisplayProductInfo extends React.Component {
    render() {
        return <div className={`product-info ${this.props.mallPromotionSection ? 'mall-promo-info' : ''}`}>{this.props.children}</div>
    }
}
